<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Pay Transport Fees</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="ay"
                            :items="ay_list"
                            item-text="ay"
                            item-value="id"
                            label="Academic Year"
                            outlined
                            persistent-hint
                            hint="Please Select Academic Year"
                            @change="getInstallmentData()"
                        />
                    </v-col>
                    <v-col cols="12" sm="3" v-if="all_learner_list!=''">
                        <p><b>Learner</b></p>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="learner"
                            :items="all_learner_list"
                            item-text="learner"
                            item-value="id"
                            label="Student"
                            @change="getLearnerTransportFeesInstallments()"
                            outlined
                            persistent-hint
                            hint="Please Select Student"
                        />
                    </v-col>
                    <!-- <v-col cols="12" sm="3" v-if="learner_transport_fees_installments.length > 0">
                    <p><b>Transport Installment List </b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="learner_transport"  :items="learner_transport_fees_installments" item-text="transportinstallment" return-object label="Transport Installment" @change="getDetails(learner_transport)"  outlined persistent-hint hint="Please Select Transport Installment"/>
                </v-col> -->
                </v-row>
            </v-card>
            <!-- <v-card class="box" v-if="transport_fees_receipts.length > 0">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Transport Fees Receipts</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>

         <v-row dense>
            <v-col cols="12" sm="12" md="12">
                    <template>
                        <v-data-table :items="transport_fees_receipts" :headers="headers" class="elevation-1 mytable" dense :search="search">
                            <template v-slot:[`item.receipt_no`]="{ item }">
                                <v-tooltip top color="warning">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no,item.ay)"> <v-icon color="warning">mdi-printer</v-icon>{{item.receipt_no}}</v-btn>
                                    </template>
                                    <span>
                                        Print Fee Receipt!!!
                                    </span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </template>
            </v-col>
        </v-row>
       </v-card> -->

            <v-card class="box" v-if="learner_transport_installments != ''">
                <v-data-table :headers="headers_new" dense class="elevation-1" :items="learner_transport_installments">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Payment-Route-Installment Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.ispaid`]="{ item }">
                        <span v-if="item.is_approved">
                            <span v-if="item.ispaid == false">
                                <v-tooltip top color="warning">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="pay(item)">Pay Fees</v-btn>
                                    </template>
                                </v-tooltip>
                            </span>
                            <span v-else> Already Paid </span>
                        </span>
                        <span v-else> Application Not Approved Yet </span>
                    </template>
                    <template v-slot:[`item.print`]="{ item }">
                        <span v-for="(item, i) in item.receipt_no" :key="i">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="print(item, item.ay)"> <v-icon color="warning">mdi-printer</v-icon>{{ item }}</v-btn>
                                </template>
                                <span> Print Fee Receipt !!! </span>
                            </v-tooltip>
                        </span>
                    </template>

                    <template v-slot:[`item.edit`]="{ item }">
                      <!-- {{item}} -->
                        <span v-for="(item1, i) in item.receipt_data" :key="i">
                            <v-tooltip top color="teal">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" class="ma-2" closable color="teal" text-color="teal" rounded small outlined @click="editItemFeeReceipt(item1)">
                                        <v-icon small>edit</v-icon>
                                        {{item1.receipt_no}}
                                    </v-btn>
                                </template>
                                <span> Edit Receipt !!!</span>
                            </v-tooltip>

                        </span>
                    </template>
                </v-data-table>
            </v-card>
            <v-card ref="payment_details" class="box" v-if="show_payment_card">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Select Payment Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row align="center" style="float: both;">
                    <!-- <v-col cols="12" sm="1"></v-col> -->
                    <v-col cols="12" sm="2">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="payment_mode" :items="mode_list" item-text="name" item-value="id" label="Payment Mode" outlined persistent-hint hint="Please Select Payment Mode" />
                        <!-- <v-combobox
              dense
              rounded
              required
              :items="mode_list"
              item-text="name"
              item-value="id"
              v-model="payment_mode"
              label="Payment Mode"
              outlined
            /> -->
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field outlined rounded label="Transaction ID" v-model="trans_id" placeholder="123" dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field label="*Amount" v-model="amount" placeholder="123" :rules="[(v) => !!v || 'Amount is required']" type="number" dense rounded outlined hint="Amount is required"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field rounded label="Remark" placeholder="Remark" v-model="receipt_remark" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on,attrs }">
                                <v-text-field dense v-model="receipt_date" v-bind="attrs" v-on="on" hint="Date" prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title :max="nowDate" @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row justify="center" dense v-if="show_payment_card && this.payment_mode">
                    <v-btn color="warning" @click="SaveTransportInstallmentFees()">Pay</v-btn>
                </v-row>
            </v-card>

          <v-dialog v-model="dialog_edit_fee" max-width="1000px">
            <v-card>
              <v-col cols="12" sm="12" md="12">
                <edit-transport-receipt
                  :key="transport_cnt"
                  :payment_mode_list="mode_list"
                  @changedialog="chnaged($event)"
                ></edit-transport-receipt>
              </v-col>
              <v-row justify="center" dense>
                <v-btn class="button mt-3" @click="dialog_edit_fee = false;edit_transport_receipt = null"
                  >Cancel</v-btn
                >
              </v-row>
            </v-card>
          </v-dialog>

        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import EditTransportReceipt from "./EditTransportReceipt";
    export default {
      components: {
          "edit-transport-receipt": EditTransportReceipt
      },
        data: () => ({
            learner_transport_installments: [],
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            title: "",
            description: "",
            transport_cnt:0,
            headers_new: [
                { text: "Sr No", value: "srno" },
                { text: "Installment", value: "name" },
                { text: "Amount", value: "amount" },
                { text: "Amount Paid Till Now", value: "paid_till_now" },
                { text: "Amount To Pay", value: "to_pay" },
                { text: "Route Stop", value: "route_stop" },
                //  { text: "Applied?", value: "is_applied" },
                { text: "Approval Status", value: "transportapprovalstatus" },
                { text: "Payment", value: "ispaid" },
                { text: "Print Receipt", value: "print" },
                { text: "Edit Receipt", value: "edit" },
            ],
            headers: [
                { text: "Sr. No.", value: "count", sortable: true },
                {
                    text: "Installment",
                    value: "learnertransportfeesinstallment",
                    sortable: true,
                },
                { text: "Receipt No", value: "receipt_no", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                { text: "Receipt Date", value: "receipt_date", sortable: true },
                { text: "Payment Mode", value: "paymentmode", sortable: true },
                { text: "Remark", value: "remark", sortable: true },
                { text: "Transaction Id", value: "transaction_id", sortable: true },
                { text: "Transaction Date", value: "transaction_date", sortable: true },
            ],
            payment_mode: "",
            receipt_date: "",
            bank: "",
            trans_id: "",
            amount: 0,
            receipt_remark: "",
            ay_list: [],
            ay: "",
            all_learner_list: [],
            learner: "",
            learner_transport_fees_installments: [],
            learner_transport: "",
            show_payment_card: false,
            transport_fees_receipts: [],
            learner_transport_fees_installment_id: "",
            mode_list: [],
            bank_list: [],
            date: new Date().toISOString().substr(0, 10),
            nowDate: new Date().toISOString().slice(0, 10),
            menu1: false,
            edit_transport_receipt:null,
            dialog_edit_fee:false
        }),
        methods: {
            clearFields(){
            this.payment_mode= "",
            this.receipt_date= ""
            this.bank= "",
            this.trans_id= "",
            this.receipt_remark=""
            },
          chnaged(dialog) {
            this.dialog_edit_fee = dialog;
            this.edit_transport_receipt = null
            this.getLearnerTransportFeesInstallments();
          },
           editItemFeeReceipt(item) {
            //console.log(item)
            this.edit_transport_receipt = null
            this.dialog_edit_fee = true;
            this.edit_transport_receipt = item;
            this.transport_cnt++
            this.$store.commit("setreceipt_data", this.edit_transport_receipt);
          },
            getInstallmentData() {
                (this.all_learner_list = []), (this.learner_transport_fees_installments = []), (this.learner_transport_installments = []), (this.learner = "");
                const data = {
                    academicYear: this.ay,
                };
                this.overlay = true;
                axios
                    .post("/ParentTransport/getInstallmentDataByAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.all_learner_list = res.data.all_learner_list;
                            if (this.all_learner_list == "") {
                                this.showSnackbar("red", "No Students Found For This Academicyear...");
                                return;
                            }
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                let routeData = this.$router.resolve({ name: "transport-receipt" });
                window.open(routeData.href, "_blank");
            },
            SaveTransportInstallmentFees() {
                const data = {
                    learner: this.learner,
                    ay: this.ay,
                    learner_transport: this.learner_transport_fees_installment_id,
                    amount: this.amount,
                    payment_mode: this.payment_mode,
                    receipt_remark: this.receipt_remark,
                    receipt_date: this.receipt_date,
                    bank: this.bank,
                    trans_id: this.trans_id,
                };
                this.overlay = true;
                axios
                    .post("/ParentTransport/SaveLearnerTransportInstallmentFees", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_transport_installments = res.data.transport_installments;
                            this.showSnackbar("green", "Payment Successful...");
                            this.show_payment_card = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.clearFields();
                        // this.selected_date=""
                    });
            },
            pay(learner_transport) {
                this.learner_transport_fees_installment_id = learner_transport.learner_installment_id;
                this.amount = learner_transport.to_pay;
                this.show_payment_card = true;
                this.showCard();
            },
            showCard() {
                setTimeout(() => {
                    this.$vuetify.goTo(this.$refs.payment_details); // for scrolling down
                }, 500);
            },
            getLearnerTransportFeesInstallments() {
                this.show_payment_card = false;
                const data = {
                    learner: this.learner,
                    ay: this.ay,
                };
                this.overlay = true;
                axios
                    .post("/ParentTransport/getLearnerTransportFeesInstallments", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_transport_fees_installments = res.data.learner_transport_fees_installments;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.learner_transport_installments = res.data.transport_installments;
                            //  this.show_payment_card=true
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                axios
                    .post("ParentTransport/paytransportFees")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            (this.all_learner_list = res.data.all_learner_list), (this.overlay = false);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        watch: {
            date(val) {
                this.receipt_date = this.formatDate(this.date);
            },
        },
        mounted() {
            this.onLoad();
            this.receipt_date = this.formatDate(this.date);
        },
    };
</script>
<style scoped>
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid orange;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
</style>
